/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RotateObservabilityCredentialRequestBody,
  RotateObservabilityCredentialRequestBody$Outbound,
  RotateObservabilityCredentialRequestBody$outboundSchema,
} from "../components/rotateobservabilitycredentialrequestbody.js";

export type RotateObservabilityCredentialSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RotateObservabilityCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  rotateObservabilityCredentialRequestBody:
    RotateObservabilityCredentialRequestBody;
};

/** @internal */
export type RotateObservabilityCredentialSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RotateObservabilityCredentialSecurity$outboundSchema:
  z.ZodMiniType<
    RotateObservabilityCredentialSecurity$Outbound,
    RotateObservabilityCredentialSecurity
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function rotateObservabilityCredentialSecurityToJSON(
  rotateObservabilityCredentialSecurity: RotateObservabilityCredentialSecurity,
): string {
  return JSON.stringify(
    RotateObservabilityCredentialSecurity$outboundSchema.parse(
      rotateObservabilityCredentialSecurity,
    ),
  );
}

/** @internal */
export type RotateObservabilityCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RotateObservabilityCredentialRequestBody:
    RotateObservabilityCredentialRequestBody$Outbound;
};

/** @internal */
export const RotateObservabilityCredentialRequest$outboundSchema: z.ZodMiniType<
  RotateObservabilityCredentialRequest$Outbound,
  RotateObservabilityCredentialRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    rotateObservabilityCredentialRequestBody:
      RotateObservabilityCredentialRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      rotateObservabilityCredentialRequestBody:
        "RotateObservabilityCredentialRequestBody",
    });
  }),
);

export function rotateObservabilityCredentialRequestToJSON(
  rotateObservabilityCredentialRequest: RotateObservabilityCredentialRequest,
): string {
  return JSON.stringify(
    RotateObservabilityCredentialRequest$outboundSchema.parse(
      rotateObservabilityCredentialRequest,
    ),
  );
}
